/* THBC main.js — vanilla JS only (jQuery removed Oct 2026).
   Each feature is isolated and guarded so one failure can never break the others.
   NAV CODE RUNS FIRST — keep it at the top of this file. */

/* 1. Desktop nav: open dropdowns on hover */
(function () {
  var menu = document.querySelector('.header__inline-menu');
  if (!menu) return;
  menu.querySelectorAll('details').forEach(function (item) {
    item.addEventListener('mouseover', function () {
      item.setAttribute('open', true);
      var ul = item.querySelector('ul');
      if (ul) {
        ul.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
      }
      item.addEventListener('mouseleave', function () {
        item.removeAttribute('open');
      });
    });
  });
})();

/* 2. Variant plus/minus toggle buttons */
(function () {
  Array.prototype.forEach.call(document.getElementsByClassName('plus-btn'), function (element) {
    element.addEventListener('click', function () {
      var target = document.getElementById(this.dataset.id);
      if (target) {
        target.classList.toggle('active');
        this.innerText = this.innerText.trim() == '+' ? '-' : '+';
      }
    });
  });
})();

/* 3. Color variant label */
document.addEventListener('DOMContentLoaded', function () {
  var radios = document.querySelectorAll("input[type='radio'][name='Color']");
  radios.forEach(function (radio) {
    radio.addEventListener('click', function () {
      var checked = document.querySelector("input[name='Color']:checked");
      var label = document.querySelector('.var_label_info');
      if (checked && label) {
        label.textContent = checked.value;
      }
    });
  });
});

/* 4. Video section: hide title overlay on play */
(function () {
  var media = document.querySelector('.video-section__media');
  if (!media) return;
  media.addEventListener('click', function () {
    document.querySelectorAll('.title-wrapper').forEach(function (el) {
      el.style.display = 'none';
    });
  });
})();

/* 5. Blog tag filter dropdown */
(function () {
  var filter = document.getElementById('BlogTagFilter');
  if (!filter) return;
  filter.addEventListener('change', function () {
    if (this.value) {
      window.location = this.value;
    }
  });
})();

/* 6. Review slider — CSS scroll-snap fallback (replaces Slick) */
(function () {
  var slider = document.querySelector('.review_slider');
  if (!slider || slider.dataset.thbcScroll) return;
  slider.dataset.thbcScroll = '1';
  slider.style.display = 'flex';
  slider.style.overflowX = 'auto';
  slider.style.gap = '16px';
  slider.style.scrollSnapType = 'x mandatory';
  slider.style.webkitOverflowScrolling = 'touch';
  Array.prototype.forEach.call(slider.children, function (child) {
    child.style.flex = '0 0 32%';
    child.style.minWidth = '260px';
    child.style.scrollSnapAlign = 'start';
  });
  document.querySelectorAll('.slide-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = btn.classList.contains('arrow-prev') ? -1 : 1;
      slider.scrollBy({ left: dir * slider.clientWidth * 0.8, behavior: 'smooth' });
    });
  });
})();

/* 7. Mobile sticky Add-to-Cart bar (product pages, ≤749px — see matching CSS in
   custom-style-thbc-v2.css). Mirrors the REAL Add to Cart button: clicking the
   sticky button clicks the real one, so variants, sold-out state, and the cart
   drawer all behave exactly as normal.
   IMPORTANT: find the BUTTON first and take its closest form — the page also
   contains a hidden Shopify installments form that posts to /cart/add, and
   grabbing the first such form finds no Add button and kills the bar. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    try {
      var info = document.querySelector('.product__info-wrapper');
      if (!info) return; /* product pages only */
      var realBtn = info.querySelector('.product-form__submit, button[name="add"]');
      if (!realBtn) return;

      var bar = document.createElement('div');
      bar.className = 'thbc-sticky-atc';
      bar.innerHTML = '<span class="thbc-sticky-atc__price"></span>' +
        '<button type="button" class="button thbc-sticky-atc__btn">Add to cart</button>';
      var priceEl = bar.querySelector('.thbc-sticky-atc__price');
      var btn = bar.querySelector('.thbc-sticky-atc__btn');
      var priceBox = info.querySelector('.price');

      function sync() {
        try {
          if (priceBox) {
            var p = priceBox.querySelector('.price-item--last') ||
              priceBox.querySelector('.price-item--sale') ||
              priceBox.querySelector('.price-item--regular');
            if (p) priceEl.textContent = p.textContent.trim();
          }
          var labelSrc = realBtn.querySelector('span') || realBtn;
          var label = labelSrc.textContent.trim();
          if (label) btn.textContent = label;
          btn.disabled = realBtn.disabled || realBtn.getAttribute('aria-disabled') === 'true';
        } catch (e) { /* never break the page over the bar */ }
      }
      sync();
      try {
        new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
        if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
      } catch (e) {}

      btn.addEventListener('click', function () {
        if (realBtn.disabled) {
          realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          realBtn.click();
        }
      });

      document.body.appendChild(bar);

      var watchTarget = realBtn.closest('.product-form__buttons') || realBtn;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -10px 0px' }).observe(watchTarget);
      } else {
        bar.classList.add('is-visible');
      }
    } catch (e) { /* bar is optional — never break the page */ }
  });
})();

/* 8. Mobile expandable search (≤749px — see matching CSS in custom-style-thbc-v2.css).
   The search bar collapses behind a magnifier icon injected into the header icon
   row. Tapping toggles the bar and focuses the input. It auto-opens on the search
   results page or whenever the input already holds a query. Tablet (750–989px)
   and desktop keep the always-visible bar. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    try {
      var block = document.querySelector('.mobile-search-header-block');
      var iconsRow = document.querySelector('.header-top-block .header__icons');
      if (!block || !iconsRow) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thbc-search-toggle';
      btn.setAttribute('aria-label', 'Search');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.73 12.44a6.44 6.44 0 1 1 .71-.71l5.41 5.42a.5.5 0 0 1-.7.7l-5.42-5.41Zm.85-5.07a5.44 5.44 0 1 1-10.88 0 5.44 5.44 0 0 1 10.88 0Z" fill="currentColor"/></svg>';
      iconsRow.insertBefore(btn, iconsRow.firstChild);

      var input = block.querySelector('input[type="search"], .search__input, input.field__input');

      function setOpen(open) {
        document.body.classList.toggle('thbc-search-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) {
          setTimeout(function () { input.focus(); }, 120);
        }
      }

      btn.addEventListener('click', function () {
        setOpen(!document.body.classList.contains('thbc-search-open'));
      });

      /* Stay open where it makes sense */
      if (location.pathname.indexOf('/search') === 0 || (input && input.value)) {
        document.body.classList.add('thbc-search-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    } catch (e) { /* search stays always-visible if anything fails */ }
  });
})();

/* 9. Delivery estimate dates (product pages — see snippets/thbc-delivery-estimate.liquid).
   Fills in "· estimated delivery Oct 21–Oct 30" next to the server-rendered
   "Ships in 1–3 business days" line. Computed fresh in the browser on every
   visit: today + processing + standard transit, business days only (weekends
   skipped), so the dates can never go stale from page caching and never need
   manual updating. The day counts live on the snippet's data-* attributes —
   edit them THERE, not here, and keep them matching Settings → Shipping. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function addBusinessDays(start, days) {
    var d = new Date(start.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) days--;
    }
    return d;
  }
  function fmt(d) {
    try {
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    } catch (e) {
      return (d.getMonth() + 1) + '/' + d.getDate();
    }
  }
  onReady(function () {
    try {
      document.querySelectorAll('[data-thbc-delivery]').forEach(function (el) {
        try {
          var slot = el.querySelector('[data-thbc-delivery-dates]');
          if (!slot || slot.dataset.thbcDone) return;
          var pmin = parseInt(el.dataset.pmin, 10) || 1;
          var pmax = parseInt(el.dataset.pmax, 10) || 3;
          var tmin = parseInt(el.dataset.tmin, 10) || 5;
          var tmax = parseInt(el.dataset.tmax, 10) || 10;
          var now = new Date();
          var earliest = addBusinessDays(now, pmin + tmin);
          var latest = addBusinessDays(now, pmax + tmax);
          slot.textContent = ' · estimated delivery ' + fmt(earliest) + '–' + fmt(latest);
          slot.dataset.thbcDone = '1';
        } catch (e) { /* skip this one, try the rest */ }
      });
    } catch (e) { /* the static "Ships in 1–3 business days" text still shows */ }
  });
})();

/* 10. Kids Size Calculator — /pages/size-guides SAFETY NET (Oct 2026).
   The calculator on that page normally runs from a script saved inside the
   page body itself (Settings → Pages). But Shopify's admin Pages editor
   silently STRIPS script tags whenever that page is saved there — that is
   exactly how the calculator died once already. This module is the backstop:
   it only activates when the page's reference table is still EMPTY (meaning
   the inline script is gone), and then rebuilds the full calculator.
   If the inline script is present, this module does nothing, so the two can
   never double-run. Size data here MUST match the page script AND the
   product-page popup (snippets/size-guide-modal.liquid) — three copies, one
   chart. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  onReady(function () {
    try {
      var tbody = document.getElementById('hbc-table-body');
      if (!tbody || tbody.children.length > 0) return; /* page's own script already ran */

      var sizes = [
        { label: "3m", hMin: 18, hMax: 23, wMin: 7, wMax: 12 },
        { label: "6m", hMin: 23, hMax: 25, wMin: 12, wMax: 16 },
        { label: "12m", hMin: 26, hMax: 29, wMin: 17, wMax: 22 },
        { label: "18m", hMin: 29, hMax: 31, wMin: 22, wMax: 27 },
        { label: "2T", hMin: 30, hMax: 33, wMin: 25, wMax: 27 },
        { label: "3T", hMin: 34, hMax: 36, wMin: 28, wMax: 33 },
        { label: "4T", hMin: 37, hMax: 39, wMin: 34, wMax: 40 },
        { label: "5T", hMin: 40, hMax: 42, wMin: 41, wMax: 45 },
        { label: "6Y", hMin: 43, hMax: 45, wMin: 46, wMax: 50 },
        { label: "7Y", hMin: 46, hMax: 48, wMin: 51, wMax: 56 },
        { label: "8Y", hMin: 49, hMax: 51, wMin: 57, wMax: 67 },
        { label: "10Y", hMin: 52, hMax: 53, wMin: 68, wMax: 78 },
        { label: "12Y", hMin: 54, hMax: 56, wMin: 79, wMax: 90 }
      ];
      var brands = {
        "Carter's": [{l:"18M",hMin:28,hMax:30.5,wMin:20,wMax:24},{l:"24M",hMin:30.5,hMax:33,wMin:24,wMax:27},{l:"3T",hMin:33,hMax:36,wMin:27,wMax:32},{l:"4T",hMin:36,hMax:40,wMin:34,wMax:38},{l:"5T",hMin:40,hMax:43,wMin:39,wMax:43},{l:"5",hMin:42,hMax:46,wMin:41,wMax:47},{l:"6",hMin:45,hMax:48,wMin:46,wMax:52},{l:"7",hMin:47,hMax:50,wMin:50,wMax:57},{l:"8",hMin:49,hMax:52,wMin:55,wMax:65},{l:"10",hMin:51,hMax:54,wMin:62,wMax:76},{l:"12",hMin:53,hMax:56,wMin:72,wMax:88}],
        "Old Navy": [{l:"18-24M",hMin:29,hMax:33,wMin:22,wMax:27},{l:"3T",hMin:33,hMax:36,wMin:28,wMax:32},{l:"4T",hMin:37,hMax:40,wMin:33,wMax:40},{l:"5T",hMin:40,hMax:43,wMin:40,wMax:45},{l:"XS(5)",hMin:42,hMax:46,wMin:41,wMax:47},{l:"S(6-7)",hMin:45,hMax:49,wMin:46,wMax:56},{l:"M(8)",hMin:49,hMax:52,wMin:55,wMax:65},{l:"L(10-12)",hMin:51,hMax:56,wMin:62,wMax:85}],
        "Gap Kids": [{l:"18-24M",hMin:29,hMax:33,wMin:22,wMax:27},{l:"3T",hMin:33,hMax:37,wMin:27,wMax:33},{l:"4T",hMin:37,hMax:41,wMin:33,wMax:40},{l:"5T",hMin:40,hMax:43,wMin:40,wMax:45},{l:"5",hMin:42,hMax:46,wMin:41,wMax:48},{l:"6",hMin:45,hMax:48,wMin:46,wMax:53},{l:"7",hMin:47,hMax:50,wMin:50,wMax:58},{l:"8",hMin:49,hMax:52,wMin:56,wMax:66},{l:"10",hMin:52,hMax:55,wMin:63,wMax:77},{l:"12",hMin:54,hMax:57,wMin:72,wMax:88}],
        "Children's Place": [{l:"3T",hMin:34,hMax:37,wMin:28,wMax:34},{l:"4T",hMin:37,hMax:41,wMin:34,wMax:41},{l:"5T",hMin:40,hMax:43,wMin:40,wMax:46},{l:"5/6",hMin:42,hMax:46,wMin:41,wMax:50},{l:"7/8",hMin:46,hMax:51,wMin:50,wMax:65},{l:"10/12",hMin:51,hMax:56,wMin:63,wMax:86}],
        "Target Cat & Jack": [{l:"18M",hMin:28,hMax:30,wMin:20,wMax:24},{l:"2T",hMin:30,hMax:33,wMin:24,wMax:28},{l:"3T",hMin:33,hMax:36,wMin:28,wMax:33},{l:"4T",hMin:37,hMax:40,wMin:33,wMax:40},{l:"5T",hMin:40,hMax:43,wMin:40,wMax:46},{l:"XS(4-5)",hMin:41,hMax:45,wMin:39,wMax:48},{l:"S(6-7)",hMin:45,hMax:49,wMin:46,wMax:57},{l:"M(8-10)",hMin:49,hMax:54,wMin:55,wMax:76},{l:"L(10-12)",hMin:53,hMax:57,wMin:68,wMax:88}],
        "H&M": [{l:"18-24M",hMin:30,hMax:33,wMin:22,wMax:27},{l:"2-3Y",hMin:33,hMax:36,wMin:27,wMax:33},{l:"3-4Y",hMin:36,hMax:39,wMin:32,wMax:39},{l:"4-5Y",hMin:39,hMax:43,wMin:38,wMax:46},{l:"5-6Y",hMin:43,hMax:46,wMin:44,wMax:52},{l:"6-7Y",hMin:46,hMax:48,wMin:50,wMax:58},{l:"7-8Y",hMin:48,hMax:51,wMin:55,wMax:66},{l:"8-10Y",hMin:51,hMax:54,wMin:63,wMax:78},{l:"10-12Y",hMin:54,hMax:57,wMin:72,wMax:90}]
      };

      var activeBrands = [];

      sizes.forEach(function (s, i) {
        var tr = document.createElement('tr');
        tr.id = 'hbc-row-' + i;
        tr.innerHTML = '<td><span class="hbc-sg__size-tag">' + s.label + '</span></td><td>' + s.hMin + '–' + s.hMax + '"</td><td>' + s.wMin + '–' + s.wMax + ' lbs</td>';
        tbody.appendChild(tr);
      });

      var pills = document.getElementById('hbc-pills');
      if (pills) {
        pills.addEventListener('click', function (e) {
          var pill = e.target.closest('.hbc-sg__pill');
          if (!pill) return;
          var b = pill.textContent.trim();
          if (pill.classList.contains('active')) { pill.classList.remove('active'); activeBrands = activeBrands.filter(function (x) { return x !== b; }); }
          else { pill.classList.add('active'); activeBrands.push(b); }
          calculate();
        });
      }

      ['hbc-height', 'hbc-weight', 'hbc-age', 'hbc-item'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.addEventListener('input', calculate);
      });

      function getBrandSize(brand, h, w) {
        var list = brands[brand]; if (!list) return null;
        var best = null, bestScore = -1;
        list.forEach(function (s) {
          var score = (h >= s.hMin && h <= s.hMax ? 50 : 0) + (w >= s.wMin && w <= s.wMax ? 50 : 0);
          if (score > bestScore) { bestScore = score; best = s.l; }
        });
        return best;
      }

      function calculate() {
        var h = parseFloat(document.getElementById('hbc-height').value);
        var w = parseFloat(document.getElementById('hbc-weight').value);
        var itemType = document.getElementById('hbc-item').value;
        var empty = document.getElementById('hbc-result-empty');
        var content = document.getElementById('hbc-result-content');

        sizes.forEach(function (s, i) { var r = document.getElementById('hbc-row-' + i); if (r) r.classList.remove('highlighted'); });

        if (!h || !w) { empty.style.display = ''; content.classList.remove('visible'); return; }

        var bestIdx = -1, bestScore = -1;
        sizes.forEach(function (s, i) {
          var hIn = h >= s.hMin && h <= s.hMax, wIn = w >= s.wMin && w <= s.wMax;
          var hDist = hIn ? 0 : Math.min(Math.abs(h - s.hMin), Math.abs(h - s.hMax));
          var wDist = wIn ? 0 : Math.min(Math.abs(w - s.wMin), Math.abs(w - s.wMax));
          var score = Math.max(0, 100 - hDist * 8 - wDist * 3);
          if (score > bestScore) { bestScore = score; bestIdx = i; }
        });

        var hIn = h >= sizes[bestIdx].hMin && h <= sizes[bestIdx].hMax;
        var wIn = w >= sizes[bestIdx].wMin && w <= sizes[bestIdx].wMax;
        var sizeUp = (!hIn && h > sizes[bestIdx].hMax) || (!wIn && w > sizes[bestIdx].wMax);
        var displayIdx = (sizeUp && bestIdx < sizes.length - 1) ? bestIdx + 1 : bestIdx;
        var d = sizes[displayIdx];
        var dHIn = h >= d.hMin && h <= d.hMax, dWIn = w >= d.wMin && w <= d.wMax;
        var perfect = dHIn && dWIn;
        var conf = perfect ? 100 : (dHIn || dWIn) ? 82 : 65;

        document.getElementById('hbc-size-badge').textContent = d.label;
        document.getElementById('hbc-size-fits').textContent = 'Fits ' + d.hMin + '–' + d.hMax + '" tall · ' + d.wMin + '–' + d.wMax + ' lbs';
        document.getElementById('hbc-size-label').textContent = perfect ? 'Perfect fit!' : sizeUp ? 'Sized up for best fit' : (dHIn || dWIn) ? 'Good fit' : 'Closest size';
        document.getElementById('hbc-conf-fill').style.width = conf + '%';
        document.getElementById('hbc-conf-text').textContent = perfect ? 'Your child falls right in the middle of this size range.' : sizeUp ? 'We recommend this size for comfortable room to grow.' : (dHIn || dWIn) ? 'Your child fits well within this size.' : 'Your child is between sizes — this is the nearest option.';

        var tip = null;
        if (sizeUp && itemType === 'pants') tip = 'For pants and leggings, we sized up based on height so the length fits best.';
        else if (sizeUp && itemType === 'dress') tip = 'For dresses, we sized up based on weight for the best fit around the chest and waist.';
        else if (sizeUp) tip = "Your child's measurements are at the top of the previous size, so we recommend this size for the best fit and room to grow.";
        else if (!dHIn && dWIn && itemType === 'pants') tip = 'For the best length on pants and leggings, you may want to try the next size up.';
        else if (!dWIn && dHIn && itemType === 'dress') tip = 'For the best fit in dresses, you may want to try the next size up.';

        var tipEl = document.getElementById('hbc-tip');
        if (tip) { tipEl.style.display = 'flex'; document.getElementById('hbc-tip-text').textContent = tip; }
        else { tipEl.style.display = 'none'; }

        var cs = document.getElementById('hbc-compare-section');
        if (activeBrands.length > 0) {
          var html = '<div class="hbc-sg__compare-item ours"><div class="hbc-sg__compare-brand">Hair Bow Co.</div><div class="hbc-sg__compare-size">' + d.label + '</div></div>';
          activeBrands.forEach(function (brand) { var sz = getBrandSize(brand, h, w) || '–'; html += '<div class="hbc-sg__compare-item"><div class="hbc-sg__compare-brand">' + brand + '</div><div class="hbc-sg__compare-size">' + sz + '</div></div>'; });
          document.getElementById('hbc-compare-grid').innerHTML = html;
          cs.style.display = '';
        } else { cs.style.display = 'none'; }

        var row = document.getElementById('hbc-row-' + displayIdx);
        if (row) { row.classList.add('highlighted'); row.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        empty.style.display = 'none';
        content.classList.add('visible');
      }
    } catch (e) { /* calculator is optional — never break the page */ }
  });
})();
